import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconSegment = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 24 24" size={size}>
      <g>
      </g>
      <g>
        <g>
          <path d="M18.7,14h-6.2c-1.4,0-2.6-1.2-2.6-2.6V5.3C10,4.5,9.4,3.9,8.6,4C3.1,4.8-1,10,0.2,16C0.9,19.9,4.1,23,8,23.8    c5.9,1.2,11.2-2.9,12-8.4C20.1,14.6,19.5,14,18.7,14z">
          </path>
          <path d="M24,10.6c-0.3-2.7-1.5-5.2-3.5-7.2c-1.9-1.9-4.5-3.2-7.2-3.5C12.6-0.1,12,0.5,12,1.2V11c0,0.6,0.5,1,1,1h9.8    C23.5,12,24.1,11.4,24,10.6z">
          </path>
        </g>
      </g>
    </BaseIcon>
  );
}

export default IconSegment;
